/* src/app/@shared/task-order-app-list-dialog/task-order-app-list-dialog.component.scss */
.cotain {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 15px;
}
.cotain p {
  min-height: 30px;
  flex-wrap: nowrap;
  margin-bottom: 16px;
  word-break: break-all !important;
}
.emp_key {
  height: auto;
  font-size: 16px;
  font-weight: bolder;
}
.emp_value {
  width: 50%;
  height: auto;
  font-size: 16px;
  font-weight: 100;
}
.emp_value p {
  font-weight: 400;
}
/*# sourceMappingURL=task-order-app-list-dialog.component.css.map */
